import { styled } from '@mui/material'
import MUIModal from '@mui/material/Modal'

const StyledModal = styled(MUIModal)({})

export const Modal = StyledModal
